import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { resolveVendorIdentity } from '../thunks/vendorIdentityThunks.ts';
import type { VendorIdentityScope } from '../thunks/vendorIdentityThunks.ts';

export interface VendorIdentityState {
  scope?: VendorIdentityScope;
  vendorId: string | null;
  status: 'idle' | 'pending' | 'resolved' | 'unresolved' | 'error';
  requestId?: string;
  error?: string;
}
const initialState: VendorIdentityState = { vendorId: null, status: 'idle' };
const slice = createSlice({ name: 'vendorIdentity', initialState, reducers: {
  clearVendorIdentity: () => initialState,
  vendorSessionChanged: (state, action: PayloadAction<VendorIdentityScope>) => JSON.stringify(state.scope) === JSON.stringify(action.payload) ? state : { ...initialState, scope: action.payload },
}, extraReducers: builder => {
  builder
    .addCase(resolveVendorIdentity.pending, (state, action) => { state.scope = action.meta.arg; state.vendorId = null; state.status = 'pending'; state.requestId = action.meta.requestId; state.error = undefined; })
    .addCase(resolveVendorIdentity.fulfilled, (state, action) => { if (state.requestId === action.meta.requestId) { state.vendorId = action.payload; state.status = action.payload ? 'resolved' : 'unresolved'; } })
    .addCase(resolveVendorIdentity.rejected, (state, action) => { if (state.requestId === action.meta.requestId) { state.vendorId = null; state.status = action.meta.aborted ? 'idle' : 'error'; state.error = action.payload; } });
} });
export const { clearVendorIdentity, vendorSessionChanged } = slice.actions;
export const vendorIdentityReducer = slice.reducer;